import { Flex, FlexProps } from "@aircall/tractor";
import { Loading } from "@dashboard/library";

export function LoadingView({
  mt = 64,
  justifyContent = "center",
  ...props
}: FlexProps) {
  return (
    <Flex
      mt={mt}
      justifyContent={justifyContent}
      alignItems="center"
      {...props}
    >
      <Loading color="icon-primary" size={40} />
    </Flex>
  );
}
